import React from "react";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" as const } },
};

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1, delayChildren: 0.1 } },
};

const BecomeMember: React.FC = () => (
  <div>
    <section style={{ background: "linear-gradient(135deg, #0a2605 0%, #0d1b2a 55%, #150308 100%)", padding: "5rem 1.5rem 6rem", position: "relative", overflow: "hidden" }}>
      <div style={{ position: "absolute", top: -120, right: -120, width: 440, height: 440, borderRadius: "50%", background: "radial-gradient(circle, rgba(109,199,68,0.18) 0%, transparent 70%)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", bottom: -100, left: -100, width: 380, height: 380, borderRadius: "50%", background: "radial-gradient(circle, rgba(198,37,45,0.12) 0%, transparent 70%)", pointerEvents: "none" }} />
      <div style={{ maxWidth: 780, margin: "0 auto", position: "relative", zIndex: 1 }}>
        <motion.div variants={stagger} initial="hidden" animate="visible">
          <motion.span variants={fadeUp} style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(109,199,68,0.12)", border: "1px solid rgba(109,199,68,0.3)", borderRadius: 999, padding: "0.35rem 1rem", color: "#6dc744", fontSize: "0.82rem", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "1rem" }}>
            <span style={{ width: 7, height: 7, background: "#6dc744", borderRadius: "50%", display: "inline-block" }} />
            Support the Market
          </motion.span>
          <motion.h1 variants={fadeUp} style={{ fontSize: "clamp(2.4rem, 5.5vw, 4rem)", fontWeight: 900, color: "white", lineHeight: 1.08, marginBottom: "1.25rem" }}>
            Become a{" "}
            <span style={{ background: "linear-gradient(90deg, #6dc744, #c6252d)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
              Member
            </span>
          </motion.h1>
        </motion.div>
      </div>
    </section>

    <section style={{ background: "#fffdf8", padding: "5rem 1.5rem" }}>
      <div style={{ maxWidth: 600, margin: "0 auto", textAlign: "center" }}>
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={stagger}>
          <motion.div variants={fadeUp} style={{ fontSize: "3.5rem", marginBottom: "1.5rem" }}>🌱</motion.div>
          <motion.h2 variants={fadeUp} style={{ fontSize: "clamp(1.4rem, 3vw, 2rem)", fontWeight: 800, color: "#0d1b2a", marginBottom: "1rem" }}>
            More Information Coming Soon
          </motion.h2>
          <motion.p variants={fadeUp} style={{ color: "#666", fontSize: "1.05rem", lineHeight: 1.75 }}>
            We're working on our membership programme. Check back soon for more details.
          </motion.p>
        </motion.div>
      </div>
    </section>
  </div>
);

export default BecomeMember;
